import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import IconDinero from '../../../Icons/IconDinero';
import IconCerdito from '../../../Icons/IconCerdito';
import IconTarjetaTicket from '../../../Icons/IconTarjetaTicket';
import IconChef from '../../../Icons/IconChef';
import clubTarjeta from '../../../assets/images/club-tarjeta-caprabo.png';
import imagenHazteClub from '../../../assets/images/img-TarjetaHazteSocio.png';

const CotitularCaprabo: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="header-tarjetas tarjetas">
        <div className="container">
          <div className="header-tarjetas__content">
            <h1 className="header-tarjetas__title">
              {t('tarjetas.tarjeta-club.title')}
            </h1>
            <p>
              {t('tarjetas.tarjeta-club.number-club')}{' '}
              <strong>123456789</strong>
            </p>
          </div>
        </div>
      </section>

      <section className="o-section--giant__top u-padding-bottom-hero section--background-color tarjetas">
        <div className="container-inner">
          <div className="img img-tarjeta">
            <img src={clubTarjeta} alt="Tarjeta Caprabo Club" />
          </div>

          <div className="tarjeta__content">
            <h2 className="bloque-datos__title">
              <span className="divider__square brand-color" />
              <span className="u-margin-right">
                {t('tarjetas.tarjeta-club.caprabo-club')}
              </span>
            </h2>

            <div className="u-display-flex-tablet u-justify-content-space-between">
              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  {t('tarjetas.tarjeta-club.no-card')}
                </p>
                <p>
                  {t('tarjetas.tarjeta-club.download')}{' '}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-demi">
                    {t('tarjetas.tarjeta-club.temporal-card')}
                  </a>
                </p>
              </div>

              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  {t('tarjetas.tarjeta-club.change-card-caprabo')}{' '}
                </p>
                <p>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-demi">
                    {t('tarjetas.tarjeta-club.to-request')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="o-section--superhero tarjetas">
        <div className="container">
          <h2 className="titulo-pagina u-text-brand u-text-center">
            {t('tarjetas.tarjeta-club.be-partner-block-title')}
          </h2>
          <div className="bloque-tarjeta bloque-tarjeta__club">
            <p className="etiqueta">{t('tarjetas.tarjeta-club.be-partner')}</p>
            <div className="bloque-tarjeta__contenido">
              <div className="img">
                <img
                  src={imagenHazteClub}
                  alt="Imagen de una tarjeta pasandosela de una persona a otra"
                />
              </div>

              <div className="bloque-tarjeta__content">
                <p className="title__medium u-margin-bottom-small">
                  {t('tarjetas.tarjeta-club.cumulative-saving-block-title')}
                </p>
                <p className="u-margin-bottom-small">
                  {t('tarjetas.tarjeta-club.advantages-and-more')}
                </p>

                <ul className="lista-ventajas">
                  <li className="lista-ventajas__item">
                    <div className="icon">
                      <IconDinero />
                    </div>

                    <span>{t('tarjetas.tarjeta-club.enjoy-offers')}</span>
                  </li>
                  <li className="lista-ventajas__item">
                    <div className="icon">
                      <IconCerdito />
                    </div>
                    <span>{t('tarjetas.tarjeta-club.see-data')}</span>
                  </li>
                  <li className="lista-ventajas__item">
                    <div className="icon">
                      <IconTarjetaTicket />
                    </div>
                    <span>{t('tarjetas.tarjeta-club.digital-ticket')}</span>
                  </li>
                  <li className="lista-ventajas__item">
                    <div className="icon">
                      <IconChef />
                    </div>
                    <span>{t('tarjetas.tarjeta-club.cook-class')}</span>
                  </li>
                </ul>

                <div className="botonera">
                  <button type="button" className="btn btn-primary">
                    {t('tarjetas.tarjeta-club.to-request')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CotitularCaprabo;
